
import vivewBase from './modules/zh/vivewBase'
import routerBase from './modules/zh/routerBase'
import helpBase from './modules/zh/help'
import privacypolicyBase from './modules/zh/privacypolicy'
export default {
  ...vivewBase,
  ...routerBase,
  ...helpBase,
  ...privacypolicyBase
}
